<template>
  <div id="verified">


    <div class="card-other">
      <h4>
        尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。
      </h4>
      <div class="main">
        <p>温馨提示： </p>
        <br>
        <p>1，所有卡必须完成实名后方能激活使用 </p>
        <br>
        <p>2，完成实名后，请打开飞行模式或者重启手机即可正常使用</p>
        <br>
        <p style="color:red">3，如有疑问，请联系客服咨询</p>
        <!-- <div class="btnOuter" style="background: #26a2ff">
          <mt-button
           style="background: #26a2ff"
            class="tag-read"
            data-clipboard-action="copy"
            :data-clipboard-text="verifiedInfo.iccid"
            type="primary"
            size="large"
            @click.prevent="sureVerifiedHandler"
            >点击复制卡号，去完成实名并绑定卡号</mt-button
          >
        </div> -->

        <wx-open-launch-weapp id="launch-btn" username="gh_5eac63f4d504" :path="path" @error="handleErrorFn"
          @launch="handleLaunchFn">
          <script type="text/wxtag-template">
            <style>
                .btn {
                  padding: 12px;
                }
                .download {
                  color: #ffffff;
                  background: #26a2ff;
                  width:100%;
                  height:50px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 16px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  margin-top:130px;
                  margin-left:auto;
                  margin-right:auto;
                  border-radius: 2px;
                }
              </style>
              <button class="download btn" style="border:none;">打开小程序进行实名登记</button>
            </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <!-- 图片实名认证 -->
    <van-dialog v-model="showimg" title="请扫描下方二维码实名" show-cancel-button>
      <img style="width:100%;" src="@/assets/suolangunicom.jpg" />
    </van-dialog>


  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { wxRequest, verified } from "@/api/user";
import { Dialog, Toast } from "vant";
import wx from 'weixin-js-sdk';

export default {
  data() {
    return {
      qianhairealname: false,
      state: "",
      supplierTypeCode: "",
      verifiedInfo: {
        iccid: localStorage.getItem('iccid'),
        name: "张三",
        userPhone: "",
        idcard: "41152819960319589X",
        code: null
      },
      src: '/jump.html',
      path: '',
      isAudit: false,
      disabledFlag: false,
      existFrontImg: false,
      existBackImg: false,
      existHandImg: false,
      frontImgUrl: "",
      backImgUrl: "",
      handImgUrl: "",
      realNameCard: -1, //需弹实名的卡
      isFirst: 0,
      showimg: false
    };
  },
  methods: {
    sureVerifiedHandler() {
      console.log('卡号' + this.verifiedInfo.iccid);
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        console.log('复制成功')
        clipboard.destroy()// 释放内存
      })
      this.showimg = true;
    },
    handleErrorFn(e) {
      console.log('fail', e.detail)
    },
    handleLaunchFn(e) {
      console.log('success', e)
    },

  },
  created() {
    if (this.$route.query.iccid && this.$route.query.iccid.length > 2) {
      this.verifiedInfo.iccid = this.$route.query.iccid;
    }
  },

  mounted() {
    if (this.$route.query.iccid && this.$route.query.iccid.length > 2) {
      this.verifiedInfo.iccid = this.$route.query.iccid;
    }
    var btn = document.getElementById('launch-btn')
    btn.addEventListener('launch', function (e) {
      console.log('success');
    });
    btn.addEventListener('error', function (e) {
      console.log('fail', e.detail);
    });
    //  this.path =  `/pages/home/index?iccid=${this.verifiedInfo.iccid}`
    if (this.verifiedInfo.iccid.length === 20) {
      this.verifiedInfo.iccid = this.verifiedInfo.iccid.substr(0, this.verifiedInfo.iccid.length - 1)
    }
    this.path = `/pages/login/index?iccid=${this.verifiedInfo.iccid}`
    wxRequest('sim/getWxConfig2', {}, 'post').then(res => { // 不管是自己写的方法还是后台给的接口方法都可以，只要这个方法有这个wx.config需要的参数
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ["scanQRCode",
          "updateAppMessageShareData",
          "updateTimelineShareData",], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'], // 跳转小程序要用到的标签
        success(res) {
          console.log(res, 11)
          // Toast.fail(res.data.message);
        },
        fail(res) {
          console.log(res, 12)
          // Toast.fail(res.data.message);
        }
      })
    })

    wx.ready(function () {
      // this.isAudit = true
      console.log('准备好了~~~');
    })
    wx.error(function (res) {
      console.log(res, 12)
      // Toast.fail(res.data.message);
    })
  },
};
</script>
<style lang="less">
#verified {
  height: 100%;

  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }

  ul {
    margin: 10px;

    li {
      line-height: 36px;
      padding: 3px 0;
      border-bottom: 1px solid #ffa33a;

      svg {
        vertical-align: middle;
        margin-right: 8px;
      }

      .codeBtn {
        float: right;
        margin-top: 2px;
      }
    }
  }

  .main {
    height: calc(100% - 48px);
    padding: 0 4%;

    form {
      height: 100%;
    }

    .line {
      border-bottom: 1px solid #e5e5e5;
    }

    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)
      background: #26a2ff;

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;

    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }

    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }

  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}

#launch-btn {
  width: 100%;
  display: block;
}</style>
